<!-- 通用自助缴费页面 -->
<template>
  <div class="home">
    <Head :logo='logo'></Head>
    <van-form>
          <van-field
            readonly
            clickable
            name="picker"
            :value="deptName"
            label="执收单位"
            placeholder="点击选择执收单位"
            @click="showPickerOne = true"
          />
          <van-popup v-model="showPickerOne" position="bottom">
            <van-picker
              show-toolbar
              :columns="deptList"
              @confirm="onConfirmOne"
              @cancel='showPickerOne=false'
            />
          </van-popup>

        <van-field
            readonly
            clickable
            name="picker"
            :value="itemName"
            label="收费项目"
            placeholder="点击选择收费项目"
            @click="showPickerTwo = true"
          />
          <van-popup v-model="showPickerTwo" position="bottom">
            <van-picker
              show-toolbar
              :columns="itemList"
              @confirm="onConfirmTwo"
              @cancel='showPickerTwo=false'
            />
          </van-popup>
        <van-field
            v-model="selfOtherPay.paymentUnit"
            name="paymentUnit"
            label="缴款单位"
            placeholder="请输入缴款单位名称"
        />
        <van-field
            v-model="selfOtherPay.idCard"
            name="idCard"
            label="证件号码"
            placeholder="请输入证件号码"
        />
        <van-field
            v-model="selfOtherPay.phone"
            type="number"
            name="phone"
            label="手机号码"
            placeholder="请输入手机号码"
        />
        <van-field
            @blur="fixed2(selfOtherPay)"
            v-model="selfOtherPay.paymentTotal"
            type="number"
            name="paymentTotal"
            label="缴费金额"
            placeholder="请输入缴费金额（元）"
        />
      <van-overlay :show="isPay" />
    </van-form>
    <van-button round block type="info" @click="pay" v-if="canPay" :disabled="isPay" class="btn">支付</van-button>
     <PrivacyDialog person='1' @getReadState='getReadState'></PrivacyDialog>
    <div id="widget" />
    <Foot  v-if='list && list.bottomMessage && list.bottomMessage.length>0' :list='list'></Foot>
  </div>
</template>

<script>
import Head from '@/components/head'
import Foot from '@/components/foot'
import List from '@/components/list'
import selectPicker from '@/components/selectPicker'
import {isEmpty,asyncLoadJs,isMoney,savePrivacy} from '@/utils/common.js'
import {Toast,Dialog} from "vant";
import {judgeVde} from "@/utils/publicJudge";
import PrivacyDialog from '@/components/dialog/privacyDialog'
// 重写 tofixed方法
Number.prototype.toFixed = function (d) {
     var s = this + "";
     if (!d) d = 0;
     if (s.indexOf(".") == -1) s += ".";
     s += new Array(d + 1).join("0");
     if (new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)) {
         var s = "0" + RegExp.$2, pm = RegExp.$1, a = RegExp.$3.length, b = true;
         if (a == d + 2) {
             a = s.match(/\d/g);
             if (parseInt(a[a.length - 1]) > 4) {
                 for (var i = a.length - 2; i >= 0; i--) {
                     a[i] = parseInt(a[i]) + 1;
                     if (a[i] == 10) {
                         a[i] = 0;
                         b = i != 1;
                     } else break;
                 }
             }
             s = a.join("").replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2");

         } if (b) s = s.substr(1);
         return (pm + s).replace(/\.$/, "");
     }
     return this + "";

 };
export default {
  name: 'selfPay',
  components: {
    Head,
    Foot,
    selectPicker,
    List,
    PrivacyDialog
  },
  data() {
    return {
        logo:'',
        vde:'',
        show: false,
        loadedMineMapJs:false,
        selfOtherPay:{
          idCard:'',
          deptId:'',
          paymentUnit:'',
          phone:'',
          itemId:'',
          paymentTotal:'',
          sysType:'4'// 业务类型，默认为其他缴费 3
        },
        deptName:'',
        itemName:'',
        itemList:[],
        showPickerOne:false,
        showPickerTwo:false,
        list:[],
        active:0,
        showModel: false,
        isPay:false,
        canPay:false,
        refreshing: false,
        deptList:[],
        isRead:false,
        details:[]
    }
  },
  created() {
    if (this.$route.query.vde === undefined) {
      this.vde = ''
    }else {
      this.vde = this.$route.query.vde
    }
    //判断vde
    judgeVde({vde:this.vde},this)
    if (this.$route.query.deptId === undefined) {
      this.selfOtherPay.deptId = ''
    }else {
      this.selfOtherPay.deptId = this.$route.query.deptId
    }
    if(isEmpty(this.selfOtherPay.deptId)){
      Toast.clear();
      Dialog.alert({
        title: "错误提示",
        message: "地址不正确，请联系执收单位"
      }).then(() => {
        this.$router.push({path:'/404'})
      });
    }else{
      this.getLock()
      this.getItemList()
      this.getDeptList()
    }
    this.getHeadImg()
    this.getFootData()

  },
  methods: {
    fixed2(val){
      val.paymentTotal=Number(val.paymentTotal).toFixed(2);
    },
     getReadState(isRead,details) {
        this.isRead = isRead;
        this.details = details;
      },
     getLock() {
        let data={
            deptId:this.vde,
            type:1
        }
        this.request({
          url:'/specialPay/isEnableSpecialPay',
          method:'get',
          params:data
        }).then((res)=>{
            if (res.data.code!=1000) {
                Dialog.alert({
                    title: '提示',
                    message: res.data.message,
                }).then(() => {
                    this.$router.push({path:'/404'})
                });
            }
        })
    },
    onConfirmOne(value) {
      this.selfOtherPay.deptId = value.deptId
      this.deptName = value.text
      this.showPickerOne = false
    },
    onConfirmTwo(value) {
      this.selfOtherPay.itemId = value.itemId
      this.itemName = value.itemName
      this.showPickerTwo = false
    },
    getDeptList:function(){
      this.request({
        url:'/selfPay/listSelfOtherDept',
        method:'get',
        params:{vde:this.vde,deptId:this.selfOtherPay.deptId,configType:'1'}
      }).then((res)=>{
          if (res.data.code == 1000) {
            this.deptList = res.data.result
            this.deptList.forEach(item => {
              if (this.selfOtherPay.deptId == item.deptId) {
                this.deptName = `[${item.deptId}]${item.deptName}`
              }
                item.text=`[${item.deptId}]${item.deptName}`
            });
          }else{
            this.deptList = []
          }
          if(this.deptList.length <= 0){
            Toast.clear();
            Dialog.alert({
              title: "错误提示",
              message: "暂无单位开通通用其他自助缴费<br/>请联系执收单位进行配置再缴费"
            }).then(() => {
              this.canPay = false
            });
          }else{
              this.canPay = true
          }
      })
    },
    getItemList:function(){
      let data = {}
      data.vde = this.vde;
      this.request({
        url:'/selfPay/listSelfOtherItem',
        method:'get',
        params:{deptId:this.selfOtherPay.deptId,configType:'1'}
      }).then((res)=>{
          if (res.data.code == 1000) {
            this.itemList = res.data.result
            this.itemList.forEach((item)=> {
              item.text = item.itemName
            })
          }else{
            this.itemList = []
          }
          if(this.itemList.length <= 0){
            Toast.clear();
            Dialog.alert({
              title: "错误提示",
              message: "该单位暂未配置通用其他自助缴费收费项目<br/>请联系执收单位进行配置再缴费"
            }).then(() => {
              this.canPay = false
            });
          }else{
              this.canPay = true
          }
      })
    },
   getHeadImg() {
      let data = {};
      data.vde = this.vde;
      this.request({
        url:'/webPortal/websitConfig',
        method:'get',
        params:data
      }).then((res)=>{
          if (res.data.code == 1000) {
            if (res.data.result.logoUrlLogin) {
              this.logo = res.data.result.logoUrlLogin;
            }else {
              this.logo = require("@/assets/img/logo.png");
          }
            document.title=res.data.result.websitTitle
            sessionStorage.setItem("title", res.data.result.websitTitle);
          } else if (res.data.code != 1000){
            this.$router.push({ path: "/404" });
          }
      })
    },
      // 获取底部数据
    getFootData() {
      let data = {
        vde:this.vde,
        type:5
      }
      this.request({
        url:'/systemManage/mobileGetMessage',
        method:'get',
        params:data
      }).then((res)=>{
          if (res.data.code != 1000) {
              //this.$router.push({path:'/404'})
          }else {
            this.list = res.data.result
          }
      })
    },
      // 存储隐私授权接口
    savePrivacy() {
        let data = {
          details:this.details,
          userId:this.selfOtherPay.paymentUnit,
          userName: this.selfOtherPay.idCard?this.selfOtherPay.idCard:
                    this.selfOtherPay.phone?this.selfOtherPay.phone:this.selfOtherPay.paymentUnit,
        };
        savePrivacy(data);
    },
    pay() {
       if (this.isRead == false) {
          Dialog.alert({
            title: "提示",
            message: "请先阅读《用户隐私政策》",
          }).then(() => {});
          return;
      };
      this.isPay = true
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      });
      const payObj = this.selfOtherPay;
      if(isEmpty(payObj.deptId)){
        Toast.clear();
        Dialog.alert({
          title: "提示",
          message: "请选择一个单位"
        }).then(() => {
            this.isPay = false
        });

        return false;
      }

      if(isEmpty(payObj.itemId)){
        Toast.clear();
        Dialog.alert({
          title: "提示",
          message: "请选择一个收费项目"
        }).then(() => {
            this.isPay = false
        });
        return false;
      }
       if(isEmpty(payObj.paymentUnit)){
        Toast.clear();
        Dialog.alert({
          title: "提示",
          message: "请输入缴款单位"
        }).then(() => {
            this.isPay = false
        });
        return false;
      }
      //判断证件号码、手机号
      if(isEmpty(payObj.idCard)){
        Toast.clear();
        Dialog.alert({
          title: "提示",
          message: "请输入证件号码"
        }).then(() => {
            this.isPay = false
        });
        return false;
      }

      if(isEmpty(payObj.phone)){
        Toast.clear();
        Dialog.alert({
          title: "提示",
          message: "请输入手机号码"
        }).then(() => {
            this.isPay = false
        });
        return false;
      }
      let testPhone =/^1\d{10}$/
      if(!testPhone.test(payObj.phone)){
        Toast.clear();
        Dialog.alert({
          title: "提示",
          message: "手机号码格式不正确"
        }).then(() => {
            this.isPay = false
        });
        return false;
      }
      //判断金额
      if(payObj.paymentTotal <= 0){
        Toast.clear();
        Dialog.alert({
          title: "提示",
          message: "金额必须大于零"
        }).then(() => {
            this.isPay = false
        });
        return false;
      }

      if(!isMoney(payObj.paymentTotal)){
        Toast.clear();
        Dialog.alert({
          title: "提示",
          message: "金额格式不正确"
        }).then(() => {
            this.isPay = false
        });
        return false;
      }
      this.savePrivacy();
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url:'/pay/payInitSelfOther',
        method:'post',
        data:payObj
      }).then((res)=>{
          if (res.data.code === 1000) {
            const result = res.data.result
            if (!this.loadedMineMapJs) {
              asyncLoadJs(result.thirdpayWidgetJs).then(() => {
                this.loadedMineMapJs = true;
                this.initPay(result);
              });
            }else{
              this.initPay(result);
            }
          }else {
            Toast.clear();
            Dialog.alert({
              title: "提示",
              message: res.data.message
            }).then(() => {});
            this.isPay = false
          }
      })
    },
    initPay:function(res) {
      let obj = {
        container: "widget", // 挂件在当前页面放置的控件ID
        merchant_no: res.merchant_no, // 分配的商户号
        merchant_order_no: res.merchant_order_no, // 订单在商户系统中的订单号
        amount: res.amount, // 订单价格，单位：人民币 分
        widget_param: res.widget_param,
        subject: res.subject,
        body: res.body,
        charge_url: res.charge_url, // 商户服务端创建Charge字符串的url
        charge_param: res.charge_param,
        device_type: res.device_type, // 设备类型
        effective_time: res.effective_time, // 当天有效，24点失效
        version_no: res.version_no
      };
      let that = this;
      const interval = setInterval(() => {
        if (this.loadedMineMapJs) {
          clearInterval(interval);
          // 调起支付
          thirdpay_widget.init(obj);
          Toast.clear();
          that.isPay = false;
        }
      }, 100);
    }
    

  }
}
</script>


<style lang="scss" scoped>
    .home {
      padding: 0 2vw;
      box-sizing: border-box;
      .btn {
        margin-top: 30px;
      }
      .van-form {
        background:rgba(255,255,255,1);
        box-shadow:4px 4px 5px 0px rgba(51,51,51,0.05);
        border-radius:5px;
      }
      .van-cell {
          background: transparent;
      }
    }
</style>